<div (click)="openDialog()" fxFlex="100" fxLayoutAlign="center center" style="cursor: pointer">
	{{ accountDetails.plan }}
</div>
